import { isUploadTokenInvalidError } from '../../hooks/deadline/use-deadline-document-reading';
import { getHttpErrorCode } from '../../utils/error.utils';
import {
  type ConsultantAssistantBlock,
  consultantAssistantBlockOf,
} from './consultant-assistant-block';

/**
 * What the card does after a failed "Crea":
 * - `reload`: another request (other tab, dialog) holds or already closed the card, whose outcomes
 *   come back with the thread;
 * - `noWorkspace`, `aiDisabled`, `actionNotFound`, `tokenExpired`: no retry can succeed, the card
 *   says what to do;
 * - `error`: network or server error, worth a retry.
 */
export type ConfirmFailureKind =
  | 'reload'
  | ConsultantAssistantBlock
  | 'actionNotFound'
  | 'tokenExpired'
  | 'error';

const CARD_HELD_ELSEWHERE_CODES: readonly string[] = [
  'assistant_action_busy',
  'assistant_action_already_confirmed',
];

export function classifyConfirmFailure(error: unknown): ConfirmFailureKind {
  if (isUploadTokenInvalidError(error)) {
    return 'tokenExpired';
  }
  const code = getHttpErrorCode(error);
  if (code !== undefined && CARD_HELD_ELSEWHERE_CODES.includes(code)) {
    return 'reload';
  }
  const assistantBlock = consultantAssistantBlockOf(error);
  if (assistantBlock) {
    return assistantBlock;
  }
  if (code === 'action_not_found') {
    return 'actionNotFound';
  }
  return 'error';
}
